





























import { Component, Vue } from 'vue-property-decorator';
import RuleDialog from '@/components/RuleDialog.vue';
import RecordDialog from '@/components/RecordDialog.vue';
import AnswerEndDialog from '@/components/AnswerEndDialog.vue';
import AnswerLateDialog from '@/components/AnswerLateDialog.vue';

@Component({
    components: {
        'rule-dialog': RuleDialog,
        'record-dialog': RecordDialog,
        'answer-end-dialog': AnswerEndDialog,
        'answer-late-dialog': AnswerLateDialog
    }
})
export default class Index extends Vue {
  
    //打开活动规则
    public onRuleBtn(): void {
        (this.$refs.rule_dialog as RuleDialog).open();
    }

    //打开红包记录
    public onRecordBtn(): void {
        (this.$refs.record_dialog as RecordDialog).open();
    }

    //继续答题
    public onContinueAnswer(): void {
        this.$router.replace('/home');
    }

    //跳转答题
    public onPlay(): void {
        let state = this.$game_data.game_status;
        if (state == 0 || state == 3) {
            this.$router.replace('/home');
        } else if (state == 5) {
            (this.$refs.answer_late_dialog as AnswerLateDialog).open();
        } else if (this.$game_data.game_status == 1) {
            (this.$refs.answer_end_dialog as AnswerEndDialog).openDialog("今日活动<br/>暂未开始", "敬请期待～");
        } else if (this.$game_data.game_status == 2) {
            (this.$refs.answer_end_dialog as AnswerEndDialog).openDialog("今日活动<br/>已经结束", "请明日再来哦～");
        } else if (this.$game_data.game_status == 4) {
            (this.$refs.answer_end_dialog as AnswerEndDialog).openDialog("活动结束<br/>感谢支持", "");
        }
    }
}
